import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Ville, EntityType } from '../entity.types';
import { EntityInfos } from './infos/EntityInfos';
import { EntityRestrictedList } from './components/EntityRestrictedList';
import { EntityBlockLine } from './components/EntityBlockLine';
import { buildCityUrl } from '../charts/villes/villesChart.utils';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../components/EntityBlockComponents';

type Props = {
  casesByCity: Array<Ville>;
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
  dontShowHref?: boolean;
};

export const EntityCasesByCity: FC<Props> = ({
  casesByCity,
  decisionCount,
  entityType,
  entityId,
  entityName,
  dontShowHref,
}) => {
  const restrictedDisplayLimit = 5;

  const source = 'expertise_city';

  return (
    <EntityBlock>
      <EntityBlockTitle>
        <FormattedMessage id="entity/expertises/CasesByCity.tsx/1" />
      </EntityBlockTitle>
      <EntityInfos
        decisionCount={decisionCount}
        entityType={entityType}
        lawyerId={entityId}
        entityName={entityName}
      />
      <div className="entity__block__value-line entity__block__head-label">
        <span>
          <FormattedMessage id="entity/expertises/CasesByCity.tsx/2" />
        </span>
        <span>
          <FormattedMessage id="entity/expertises/CasesByCity.tsx/3" />
        </span>
      </div>
      <EntityRestrictedList
        list={casesByCity}
        limit={restrictedDisplayLimit}
        source={source}
      >
        {newCasesByCity =>
          newCasesByCity.map(city => {
            const url = buildCityUrl({
              entityName,
              ville: city.name,
              entityType,
              entityIdUrlArg: entityId,
            });

            return (
              <EntityBlockLine
                data-test-id={city.key}
                key={city.key}
                label={city.name}
                value={city.count}
                url={dontShowHref ? undefined : url}
                source={source}
              />
            );
          })
        }
      </EntityRestrictedList>
    </EntityBlock>
  );
};
